export const complaintStatusIds = {
  received: 1,
  inprogress: 2,
  completed: 3,
};
export const requestStatusIds = {
  inprogress: 1,
  approved: 2,
  rejected: 3,
};
export const requestTypes = {
  addNote: {
    id: 1,
    name: 'إضافة ملاحظة',
  },
  reopen: {
    id: 2,
    name: 'إعادة فتح الطلب',
  },
};
export const clarificationRequestTypes = {
  clarification: 3,
  addAttachment: 4,
};
// export const clarificationRequestTypes = [
//   {
//     id: 1,
//     name: 'طلب إضاح',
//   },
//   {
//     id: 2,
//     name: 'طلب اضافة مرفق',
//   },
// ];
export const mainComplaintCategories = {
  relatedToCase: 10,
  relatedToExecution: 12,
  other: 14,
};